export function mapValueModel(values) {
  return values.map((value, index) => ({
    id: index,
    //value: value.value,
    //label: value.label,
    ...value,
  }));
}
